// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"e91b8a21","84":"a243e988","115":"97e094f9","379":"18aa5651","509":"53caea03","743":"97e094f9","752":"97e094f9","870":"3bcf5d71","876":"97e094f9"}[chunkId] + ".chunk.css";
};